import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const steps = [
  {
    label: '回答する',
    description: (
      <React.Fragment>
        <img src="/images/stepper/stepperpc1.png" alt="ステップ1の画像" style={{ width: '100%', border: '3px solid whitesmoke', marginTop: '30px' }} />
        <p>AIが出題するお題を参考に文章を作成しましょう。<br /><small>(ちなみにお題は使わなくても添削してくれます。)</small></p>
        <p><b>【添削】ボタンをクリックすると、AIが自動的に添削してくれます。</b></p>
      </React.Fragment>
    )
  },
  {
    label: 'AIを活用する',
    description: (
      <React.Fragment>
        <img src="/images/stepper/stepperpc2.png" alt="ステップ2の画像" style={{ width: '100%', border: '3px solid whitesmoke', marginTop: '30px' }} />
        <p>添削してもらった文章を基に、</p>
        <p><b>「肉付け(文章を複雑化)」、「シンプル(わかりやすい)」「言い換え(別の表現)」</b></p>
        <p>ボタンを活用すると、自分の視点では使わない韓国語単語や表現を学習することができます。
        </p>
      </React.Fragment>
    )
  },
  {
    label: '次の質問へ',
    description: (
      <React.Fragment>
        <img src="/images/stepper/stepperpc3.png" alt="ステップ2の画像" style={{ width: '40%', border: '3px solid whitesmoke', marginTop: '30px' }} />
        <p>【次の質問】ボタンをクリックすると、次のお題が表示されるので、ここまでの流れと同じようにご利用ください。</p>
      </React.Fragment>
    )
  },
];

export default function LpStepperPc() {
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <>
    <Card variant="outlined" style={{ minHeight: '390px', padding: '40px 30px 0px 30px' }}>
      <Box sx={{ width: '100%' }}>
        <Stepper activeStep={activeStep}>
          {steps.map((step) => {
            return (
              <Step key={step.label}>
                <StepLabel>{step.label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Typography style={{ marginTop: '30px' }} sx={{ mt: 2, mb: 1 }}>
              ハングルマッチAIの使い方手順は以上です。
            </Typography>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {steps[activeStep].description}
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Button
                color="inherit"
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
              >
                <b>戻る</b>
              </Button>
              <Box sx={{ flex: '1 1 auto' }} />

              <Button onClick={handleNext}>
                <b>{activeStep === steps.length - 1 ? '終了' : '次へ'}</b>
              </Button>
            </Box>
          </React.Fragment>
        )}
      </Box>
    </Card>
    <div className="card-img">
        <img src="/images/stepper/stepperpc4.png" alt="ステップ1の画像" style={{ width: '70%' }} />
    </div>
    </>
  );
}